import { _fetch } from "@/lib/queries/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

export default function useConfirmLineItems({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  const queryClient = useQueryClient();
  const { teamSlug } = useParams();
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ quoteRevisionId }: { quoteRevisionId: string }) =>
      confirmLineItems(teamSlug!, quoteRevisionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
      });
      onSuccess();
    },
    onError,
  });
  return { confirmLineItems: mutate, isPending };
}

async function confirmLineItems(
  teamSlug: string,
  quoteRevisionId: string,
): Promise<unknown> {
  return _fetch(
    `teams/${teamSlug}/quote_revisions/${quoteRevisionId}/confirm_line_items`,
    "POST",
  );
}
